import { APPLICATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

export function setupNegotiation(): void {

  applicationModuleRegistry.register({
    entry: 'negotiation',
    id: 'negotiation',
    name: 'pa.negotiation',
    route: APPLICATION_ROUTES.NEGOTIATION,
    order: 3,
  });
}
